// extracted by mini-css-extract-plugin
module.exports = {"colWrapper":"AccountTypeHero_colWrapper__34lEA","content":"AccountTypeHero_content__sczHb","link":"AccountTypeHero_link__X_dw8"};